import { render } from "./AHJTableView.vue?vue&type=template&id=1f5215d0&scoped=true"
import script from "./AHJTableView.vue?vue&type=script&lang=js"
export * from "./AHJTableView.vue?vue&type=script&lang=js"

import "./AHJTableView.vue?vue&type=style&index=0&id=1f5215d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5215d0"]])

export default __exports__